// LanguageSelector.jsx - Selector de idioma
import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { currentLanguage, changeLanguage } = useLanguage();

  const languages = [
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'en', name: 'English', flag: '🇺🇸' }
  ];

  return (
    <div className="language-selector">
      <div className="language-dropdown">
        <button className="language-toggle">
          {languages.find(lang => lang.code === currentLanguage)?.flag}
          <span className="language-name">
            {languages.find(lang => lang.code === currentLanguage)?.name}
          </span>
          <span className="dropdown-arrow">▼</span>
        </button>
        
        <div className="language-menu">
          {languages.map(language => (
            <button
              key={language.code}
              className={`language-option ${currentLanguage === language.code ? 'active' : ''}`}
              onClick={() => changeLanguage(language.code)}
            >
              <span className="flag">{language.flag}</span>
              <span className="name">{language.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageSelector;
